module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//store-goods_commit.png?v=9a5cfeb3";